import { loadable } from '@change/core/react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'search',
		path: '/search',
		component: loadable(async () => import(/* webpackChunkName: "pages/search" */ './index'), {
			exportName: 'Search',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			enabled: true,
			seo: false,
		},
	},
];
